export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';

export function authFail() {
  return {
    type: AUTH_FAIL
  };
}

export function authSuccess(jwt) {
  return {
    type: AUTH_SUCCESS,
    jwt: jwt
  };
}